// this reducer stores treasure challenges, player challenges, and anytime hunt photos

const initialState = {
  //treasure data
  treasureChallengeData: false,
  treasureChallengePhotos: null,
  treasureChallengeHighestCompletion: null,

  //location challenge data
  locationChallengeData: null,

  //playerchallenge data
  playerChallengeData: null,
  playerChallengePhotos: [],
  playerChallengeDataActive: [],
  playerChallengeDataCompleted: [],
  playerChallengeDataActiveCount: 0,
  playerChallengeDataCount: 0,

  anyTimePhotos: [],
};

import {createSlice} from '@reduxjs/toolkit';

const parseTreasureChallengeData = (treasureChallengeData) => {
  let highestCompletion = null;
  let treasureChallengePhotos = [];
  treasureChallengeData &&
    treasureChallengeData?.map?.((challenge) => {
      if (challenge.photoUrl) {
        highestCompletion = challenge.index;
        treasureChallengePhotos.push({
          challenge: challenge.task,
          downloadURL: challenge.photoUrl,
          pointsEarned: challenge.pointsEarned,
          userId: challenge.completingUserId || '',
          shareUUID: challenge.shareUUID || '',
          thumbnail: challenge.thumbnail,
          isVideo: !!challenge.thumbnail ? true : false,
          type: 'Treasure',
        });
      }
    });

  return {
    treasureChallengeData: treasureChallengeData,
    treasureChallengePhotos,
    treasureChallengeHighestCompletion: highestCompletion,
  };
};

const gameSlice = createSlice({
  name: 'game',
  initialState,
  reducers: {
    updateTreasureChallengeData(state, {payload: treasureChallengeData = {}}) {
      const parsedData = parseTreasureChallengeData(treasureChallengeData);
      console.log('updateTreasureChallengeData');
      state.treasureChallengeData = parsedData?.treasureChallengeData;
      state.treasureChallengePhotos = parsedData?.treasureChallengePhotos;
      state.treasureChallengeHighestCompletion =
        parsedData?.treasureChallengeHighestCompletion;
    },
    updatePlayerChallengeData(state, {payload = {}}) {
      console.log('updatePlayerChallengeData', {payload});
      state.playerChallengeData = payload?.playerChallengeData;
      state.playerChallengePhotos = payload?.playerChallengePhotos;
      state.playerChallengeDataActive = payload?.playerChallengeDataActive;
      state.playerChallengeDataCompleted =
        payload?.playerChallengeDataCompleted;
      state.playerChallengeDataActiveCount =
        payload?.playerChallengeDataActiveCount;
      state.playerChallengeDataCount = payload?.playerChallengeDataCount;
    },
    updatePlayerChallengeDataNotification(state, {payload = {}}) {
      state.playerChallengeDataActive = payload?.playerChallengeDataActive;
      state.playerChallengeDataActiveCount =
        payload?.playerChallengeDataActiveCount;
    },
    updateAnytimePhotosData(state, {payload: anyTimePhotos = {}}) {
      state.anyTimePhotos = anyTimePhotos;
    },
  },
});

export const {
  updateTreasureChallengeData,
  updatePlayerChallengeData,
  updatePlayerChallengeDataNotification,
  updateAnytimePhotosData,
} = gameSlice.actions;
export default gameSlice.reducer;
